export type FeedbackTextConfig = {
    titleKey: string;
    descriptionKey: string;
    primaryButtonKey: string;
};

export const FEEDBACK_CUSTOMER_VERIFICATION_TEXT_MAP: Record<string, FeedbackTextConfig> = {
    cif: {
        titleKey: 'noObddocumentTypeCifTitle',
        descriptionKey: 'noObddocumentTypeCifDescription',
        primaryButtonKey: 'buttonUnderstoodFeedback',
    },
};
